"use client";

import { useTerms } from "@/hooks/usePublicData";
import { useLocale } from "next-intl";
import LegalLayout, { type LegalSection } from "./LegalLayout";

export default function TermsClient() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const { data, isLoading } = useTerms();

  const title = data ? (isAr ? data.title.ar : data.title.en) : isAr ? "الشروط والأحكام" : "Terms & Conditions";
  const subtitle = data ? (isAr ? data.subtitle.ar : data.subtitle.en) : "";
  const sections: LegalSection[] = (data?.categories || []).map((c) => ({
    title: isAr ? c.title.ar : c.title.en,
    html: isAr ? c.content.ar : c.content.en,
  }));

  return <LegalLayout title={title} subtitle={subtitle} sections={sections} isLoading={isLoading} />;
}
